import './polyfills';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import store, { history } from './store';
import initSentry from './sentry';
import App from './components/App';
import './styles/main.css';


initSentry();

const rootEl = document.getElementById('root');
if (rootEl.hasChildNodes()) {
  hydrate(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <App />
        </div>
      </ConnectedRouter>
    </Provider>,
    rootEl
  );
} else {
  render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <App />
        </div>
      </ConnectedRouter>
    </Provider>,
    rootEl
  );
}



// WEBPACK FOOTER //
// ./src/index.js